/**
 * Remove DIY accessory variants from cart when a DIY-tagged product is removed.
 */
/**
 * 当购物车中移除商品（quantity 变为 0）时：
 * 读取该商品行的 data-product-tags
 * 若包含 DIY 标签，自动将以下 4 个配件变体从购物车中移除：
 * 40070200328265
 * 54720259293257
 * 55490121695305
 * 55490187001929
 * 移除后触发 cart:rerender 刷新购物车 UI
 */
(function () {
  var DIY_TAG = 'DIY';
  var ACCESSORY_VARIANT_IDS = [
    '40070200328265',
    '54720259293257',
    '55490121695305',
    '55490187001929'
  ];

  function hasDiyTag(productTags) {
    if (!productTags) return false;

    return productTags.split(',').some(function (tag) {
      return tag.trim() === DIY_TAG;
    });
  }

  window.removeDiyAccessoriesOnCartRemove = async function (productTags) {
    if (!hasDiyTag(productTags)) return;

    var cartResponse = await fetch(window.routes.cartUrl + '.js', {
      credentials: 'same-origin',
      method: 'GET'
    });

    if (!cartResponse.ok) return;

    var cart = await cartResponse.json();
    var updates = {};

    cart.items.forEach(function (item) {
      var variantId = String(item.variant_id);

      if (ACCESSORY_VARIANT_IDS.indexOf(variantId) !== -1) {
        updates[variantId] = 0;
      }
    });

    if (Object.keys(updates).length === 0) return;

    await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates: updates })
    });

    document.dispatchEvent(new CustomEvent('cart:rerender'));
  };
})();
